import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_outlined = _resolveComponent("search-outlined")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.showcontents?'presuffix seractive ' :'presuffix'),
    style: {"padding-top":"10px"}
  }, [
    _createVNode(_component_a_input, {
      placeholder: _ctx.$et('search'),
      value: _ctx.searchName,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchName) = $event)),
      onKeyup: _withKeys($setup.inputs, ["enter"]),
      onFocus: _cache[1] || (_cache[1] = ($event: any) => ($setup.foucs(true))),
      "allow-clear": ""
    }, {
      prefix: _withCtx(() => [
        _createVNode(_component_search_outlined, { style: {"color":"#CBCBCB","fontSize":"22px"} })
      ]),
      _: 1
    }, 8, ["placeholder", "value", "onKeyup"]),
    (_ctx.showcontents)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "cancels",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.foucs(false)))
        }, _toDisplayString(_ctx.$et('cancel')), 1))
      : _createCommentVNode("", true)
  ], 2))
}